module.exports = __webpack_public_path__ + "img/lower-right.5d440dbb.svg";